import React, { useContext, useMemo } from 'react';
import { ComponentContext } from '../../contexts/components-context';
import { useImageToBase64 } from '../../hooks/image-to-base64';
import { getMediaManagerImageUrl } from '../../utils/media-manager-handler';
export const Image = ({ definition }) => {
    const { width, height, image: { uri, originalHeight, originalWidth }, opacity, } = definition;
    const { SelectionMarker } = useContext(ComponentContext);
    const imageUrl = useMemo(() => getMediaManagerImageUrl({ id: uri, width: originalWidth, height: originalHeight }, width, height), [width, height, uri, originalWidth, originalHeight]);
    const { href } = useImageToBase64(imageUrl);
    const selectionMarker = SelectionMarker({ width, height });
    return (React.createElement("svg", { width: width, height: height, style: {
            pointerEvents: 'all',
        } },
        React.createElement("image", { href: href, height: height, width: width, preserveAspectRatio: "xMidYMid", "data-not-bounding": true, style: { opacity, pointerEvents: selectionMarker === null ? 'none' : 'all' } }),
        selectionMarker));
};
//# sourceMappingURL=image.js.map